import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import {useEffect,useState} from 'react';
import {useNavigate,useParams,useLocation} from 'react-router-dom';
import {useAuth} from '@/context/AuthContext';
import {api} from '@/lib/api';
import BrandDirectory from '@/pages/BrandDirectory';
import {BrandHomeReturn} from '@/components/BrandHomeNavigation';
import {cachedBrandHome,cacheBrandHome,brandHomeUrl,brandExploreUrl,shouldLaunchBrand} from '@/brandHome';

export default function BrandAppEntry(){
  useUiLanguage();
  const {brandSlug}=useParams(),nav=useNavigate(),location=useLocation();
  const {status,user}=useAuth();
  const launch=shouldLaunchBrand(location.search);
  const [state,setState]=useState('loading'),[retry,setRetry]=useState(0);
  useEffect(()=>{
    if(!launch||status==='loading')return;
    let active=true;setState('loading');
    const run=async()=>{
      if(status==='authed'&&user?.role==='client'){
        const data=await api.get(`/client/brands/${encodeURIComponent(brandSlug)}/home`);
        if(!active)return;
        const home=data.home||(data.studios?.length===1?data.studios[0]:null);
        cacheBrandHome(brandSlug,home);
        if(home){nav(brandHomeUrl(brandSlug,home.slug),{replace:true});return;}
        nav(brandExploreUrl(brandSlug),{replace:true});return;
      }
      // A launch hint survives Home Screen installation even without copied storage.
      const candidate=cachedBrandHome(brandSlug)||new URLSearchParams(location.search).get('studio');
      if(candidate&&brandHomeUrl(brandSlug,candidate,'login')){
        let data;
        try{data=await api.get(`/public/studios/${encodeURIComponent(candidate)}`);}
        catch(e){if(e?.response?.status!==404)throw e;}
        if(!active)return;
        if(data?.studio?.brand_network?.slug===brandSlug){nav(brandHomeUrl(brandSlug,candidate,'login'),{replace:true});return;}
        cacheBrandHome(brandSlug,null);
      }
      if(active)setState('browse');
    };
    run().catch(()=>{if(active)setState('error');});
    return()=>{active=false;};
  },[brandSlug,launch,location.search,status,user?.id,user?.role,nav,retry]);
  if(!launch||state==='browse')return <BrandDirectory homeReturn={<BrandHomeReturn brandSlug={brandSlug}/>}/>;
  if(state==='error')return <main className="grid min-h-screen place-items-center bg-zinc-950 p-6 text-white"><section className="max-w-md space-y-4"><h1 className="text-xl">{tr("Non riesco ad aprire la tua sede")}</h1><p>{tr("Controlla la connessione e riprova.")}</p><button className="min-h-11 rounded border px-4" onClick={()=>setRetry(n=>n+1)}>{tr("Riprova")}</button><a className="block min-h-11 underline" href={brandExploreUrl(brandSlug)}>{tr("Esplora il Brand")}</a></section></main>;
  return <main className="grid min-h-screen place-items-center bg-zinc-950 p-6 text-white"><p role="status">{tr("Apro la tua sede…")}</p></main>;
}
